(function() {
    'use strict';

    angular.module('app').factory('AccessManagerService', AccessManagerService);

    AccessManagerService.$inject = ['DistributionService'];

    function AccessManagerService(DistributionService) {
        var model = false;
        var accesses = false;

        var navigation = {
            object: {
                name: 'app.object',
            },
            route: {
                name: 'app.route',
            },
            report: {
                distribution: ['ww'],
                name: 'app.report',
            },
            link: {
                distribution: ['ww'],
                name: 'app.link',
            },
            premium: {
                positions: {
                    ngeosent: {
                        distribution: ['ww'],
                        name: 'app.ngeosent',
                        access: {
                            type: 'extra-feature',
                            value: 'geo-sent-localization',
                        },
                    },
                    puesc: {
                        name: 'app.puesc',
                        access: {
                            type: 'extra-feature',
                            value: 'puesc-access',
                        },
                    },
                    harmonograms: {
                        distribution: ['ww'],
                        name: 'app.harmonograms.vehicles',
                        access: {
                            type: 'setting-on',
                            value: ['harmonograms', 'on'],
                        },
                    },
                    planning: {
                        distribution: ['ww'],
                        name: 'app.planning',
                        access: {
                            type: 'extra-feature',
                            value: 'route-planning',
                        },
                    },
                    service: {
                        distribution: ['ww'],
                        name: 'app.service',
                        access: {
                            type: 'extra-feature',
                            value: 'login-notifications-service',
                        },
                    },
                    shares: {
                        distribution: ['ww'],
                        name: 'app.shares',
                        access: {
                            type: 'extra-feature',
                            value: 'share-groups',
                        },
                    },
                },
            },
            admin: {
                distribution: ['ww'],
                access: {
                    type: 'administrator',
                },
                positions: {
                    logins: {
                        name: 'app.logins',
                    },
                    groups: {
                        name: 'app.groups',
                    },
                    drivers: {
                        name: 'app.drivers',
                    },
                    worktime: {
                        name: 'app.worktime_setting',
                    },
                },
            },
            root: {
                access: {
                    type: 'extra-feature',
                    value: 'application-management',
                },
                positions: {
                    hybrid: {
                        name: 'app.hybrid',
                        access: {
                            type: 'extra-feature',
                            value: 'application-management',
                        },
                    },
                    settings: {
                        name: 'app.application_setting',
                        access: {
                            type: 'extra-feature',
                            value: 'application-setting',
                        },
                    },
                    messages: {
                        name: 'app.messages',
                        access: {
                            type: 'extra-feature',
                            value: 'send-messages',
                        },
                    },
                    puesc: {
                        name: 'app.puesc-management',
                    },
                },
            },
            settings: {
                distribution: ['ww'],
                name: 'app.settings'
            },
            messenger: {
                distribution: ['ww'],
                name: 'app.messenger',
            },
        };

        function _isInDistribution(items) {
            if (!items) {
                return true;
            }

            return items.indexOf(DistributionService.code()) >= 0;
        }

        function isAdministrator() {
            if (!model) {
                return false;
            }

            return model.roleId <= 0;
        }

        function hasSettingOn(path) {
            if (!model) {
                return false;
            }

            var o = model.userSettings;

            for (var i = 0; i < path.length; i++) {
                var value = path[i];

                if (o.hasOwnProperty(value)) {
                    o = o[value];

                    if (i === path.length - 1) {
                        return !!o;
                    }
                } else {
                    return false;
                }
            }

            return false;
        }

        function hasExtraFeature(item) {
            if (!model) {
                return false;
            }

            return model.extraFeatures.indexOf(item) >= 0;
        }

        function hasPuescLimitation() {
            if (!model) {
                return false;
            }

            return hasExtraFeature('puesc-limited');
        }

        function _getSingleAccess(access) {
            switch (access.type) {
                case 'extra-feature':
                    return hasExtraFeature(access.value);
                case 'administrator':
                    return isAdministrator();
                case 'setting-on':
                    return hasSettingOn(access.value);
            }

            return false;
        }

        function getAccesses() {
            var results = {};

            for (var i in navigation) {
                var item = navigation[i];

                results[i] = {
                    positions: {},
                };

                if (item.name) {
                    results[i].name = item.name;
                }

                if (!_isInDistribution(item.distribution)) {
                    results[i].access = false;
                } else {
                    results[i].access = item.access ? _getSingleAccess(item.access) : true;
                }

                var positions = item.positions ? item.positions : {};
                var access = false;

                if (Object.keys(positions).length === 0) {
                    continue;
                }

                for (var j in positions) {
                    var subitem = positions[j];

                    results[i].positions[j] = {
                        access: false,
                    };

                    if (subitem.name) {
                        results[i].positions[j].name = subitem.name;
                    }

                    if (!results[i].access) {
                        continue;
                    }

                    if (!subitem.access) {
                        subitem.access = item.access;
                    }

                    if (!_isInDistribution(subitem.distribution)) {
                        continue;
                    }

                    if (subitem.access) {
                        var sub = _getSingleAccess(subitem.access);

                        results[i].positions[j].access = sub;

                        if (sub) {
                            access = true;
                        }
                    } else {
                        results[i].positions[j].access = true;
                        access = true;
                    }
                }

                if (!access) {
                    results[i].access = false;
                }
            }

            accesses = results;

            return true;
        }

        function has(item, sub) {
            if (sub !== void 0) {
                return _subitem(item, sub);
            }

            return accesses[item].access;
        }

        function _subitem(item, sub) {
            if (!accesses[item] || !accesses[item].positions[sub]) {
                return false;
            }

            return accesses[item].positions[sub].access;
        }

        function list() {
            var results = {};

            for (var i in accesses) {
                var item = accesses[i];

                if (item.name) {
                    results[item.name] = item.access;
                }

                for (var j in item.positions) {
                    var subitem = item.positions[j];

                    if (subitem.name) {
                        results[subitem.name] = subitem.access;
                    }
                }
            }

            return results;
        }

        function isAutenticated() {
            return model && model.loginId;
        }

        return {
            has: has,
            update: update,
            list: list,
            isAutenticated: isAutenticated,
            isAdministrator: isAdministrator,
            hasSettingOn: hasSettingOn,
            hasExtraFeature: hasExtraFeature,
            hasPuescLimitation: hasPuescLimitation,
        };

        function update(m) {
            model = m;
            getAccesses();

            return true;
        }
    }
})();
